<template>
  <v-container-restricted
    class="d-flex flex-column align-center text-center text-md-left"
    :class="Spacings.homePageSectionPadding"
  >
    <underlined-heading :text="$t('taHome.whyChooseUs')"></underlined-heading>

    <v-row
      justify="center"
      class="text-left"
      :class="Spacings.homePageHeadingMargin"
      no-gutters
    >
      <v-col
        class="px-0 pb-3 pt-0 pa-sm-3"
        cols="12"
        sm="6"
        v-for="(point, index) in whyUsData"
      >
        <SlideOnIntersectContainer
          :direction="
            index === 0
              ? 'top-left'
              : index === 1
              ? 'top-right'
              : index === 2
              ? 'bottom-left'
              : 'bottom-right'
          "
        >
          <template #default>
            <v-card class="h-100 rounded-xl" elevation="0">
              <v-row
                no-gutters
                justify="center"
                class="text-center text-md-left"
              >
                <v-col cols="8" md="4">
                  <div class="w-100" style="aspect-ratio: 4/2.5">
                    <Image
                      :cover="false"
                      :full-height="true"
                      :full-width="true"
                      :src="point.imgUrl"
                    ></Image>
                  </div>
                </v-col>
                <v-col cols="12" md="8" class="pa-3">
                  <h4 class="text-h6">{{ point.name }}</h4>
                  <p class="text-card">{{ point.description }}</p>
                </v-col>
              </v-row>
            </v-card>
          </template>
        </SlideOnIntersectContainer>
      </v-col>
    </v-row>
  </v-container-restricted>
</template>
<script lang="ts" setup>
import { Spacings } from "~/core/constants/vuetify-class-constants/spacings";

const whyUsData: { name: string; description: string; imgUrl: string }[] = [
  {
    name: "Expert Team",
    description:
      "Our team consists of industry-leading professionals with years of experience and in-depth knowledge in their respective fields. ",
    imgUrl:
      "https://img.freepik.com/free-vector/business-people-professional-outfits_23-2148453659.jpg?t=st=1717667405~exp=1717671005~hmac=80ed7d7ff566a2d7c9a6d3a941c7301e82cb019d2430769b69b9b94c32334faf&w=300",
  },
  {
    name: "Innovative Solutions",
    description:
      "We pride ourselves on our ability to think outside the box and develop creative, forward-thinking solutions tailored to meet our clients' unique needs.",
    imgUrl:
      "https://img.freepik.com/free-vector/innovation-concept-illustration_114360-5768.jpg?t=st=1717668079~exp=1717671679~hmac=146209a2986489ce9ca3f4f0aefa6a3d7d8f0031e312920e4ff622fc4d7c577f&w=300",
  },
  {
    name: "Proven Track Record",
    description:
      "Our portfolio showcases a variety of successful projects and satisfied clients who have benefited from our expertise and dedication.",
    imgUrl:
      "https://img.freepik.com/free-vector/approval-mark-product-advantage-rating-reviews-meeting-requirements_335657-3106.jpg?t=st=1717668329~exp=1717671929~hmac=d7b6827b74c530219f3f7d2ce185ea05ee811bde772d6069193ecf9008bff8c2&w=300",
  },
  {
    name: "Customer Centric Approach",
    description:
      "At the heart of our business is a strong focus on our clients. We prioritize understanding their needs, goals, and challenges to provide solutions to their requirements.",
    imgUrl:
      "https://img.freepik.com/free-vector/end-user-with-magnifier-finding-information-laptop-with-headset-customer-self-service-e-support-system-electronic-customer-support-concept_335657-2331.jpg?t=st=1717668482~exp=1717672082~hmac=33b5d21256e0b5afd34ae5fddd84ad11ab390089aafdf025e65864b4aa2be150&w=300",
  },
];
</script>
